import { motion } from "framer-motion";

export const EASE = [0.22, 0.8, 0.24, 1];

export function Reveal({ children, delay = 0, y = 36, className }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, delay = 0 }) {
  return (
    <>
      {lines.map((line, i) => (
        <span className="mask-line" key={i}>
          <motion.span
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.1, delay: delay + i * 0.13, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </>
  );
}
